import React, { useEffect, useState } from "react";
import { Col, Card, Table, Alert, Spinner,Modal,Dropdown } from "react-bootstrap";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
function Stores() {
  var history = useHistory();
  const [stores, setStores] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [show1, setShow1] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [category, setCategory] = useState("");
  const [allCategoryObject, setAllCategoryObject] = useState([]);
  const [catId, setCatId] = useState("");
  function getData() {
    axios
      .get(
        `${Baseurl.baseurl6}/go-grocery/shop/get-all-shop-details`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setStores(res.data.details);
        }
      });
  }
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  useEffect(() => {
    getData();
  }, []);
  function addCategoryToSubStore(){
    if(selectedCategory.length!==0){
        category.splice(0, selectedCategory.length);
    }
    let catFields = {
      subShopId: category,
      };
      axios
        .put(
          `${Baseurl.baseurl6}/go-grocery/shop/add-subshop-to-shop/${catId}`,
          catFields
        )
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("updated", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
      setShow1(false)
  }
  function getCategory(subShop){
    axios
    .get(`${Baseurl.baseurl6}/go-grocery/sub-shop/get-all-sub-shop`)
    .then((res) => {
      setAllCategoryObject(res.data.details);
      setSelectedCategory(subShop)
    });
  }
  const removeFromSubStore = (selectedValues,removed) => {
    console.log("selectionsss",removed)
    if(removed&&deleteStatus){
      deleteCategoryfromSubShop(removed._id)
    }
  };
  function deleteCategoryfromSubShop(id){
    let catFields = {
      subShopId: id,
      };
      axios
        .put(
          `${Baseurl.baseurl6}/go-grocery/shop/remove-subshop-from-shop/${catId}`,
          catFields
        )
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("deleted", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
      setShow1(false)
  }
  const selection1 = (selectedValues) => {
    let name = [];
    selectedValues.map((val) => {
      name.push(val._id);
    });
    
    setCategory(name);
  };
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{deleteStatus?"Remove Category":"Add Category"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
        <div className="row">
        <div className="col-sm-2">
            
              <label className="col-form-label" htmlFor="val-confirm-password">
                Category<span className="text-danger">*</span>
              </label>
            </div>
            <div className="col-sm-10">
              <Multiselect
                options={allCategoryObject}
                displayValue="Name"
                onRemove={removeFromSubStore}
                onSelect={selection1}
                selectedValues={selectedCategory}
              />
            </div>
        </div>
        </Modal.Body>
        {!deleteStatus&&(
              <Modal.Footer>
              <button
                onClick={() => {
                 addCategoryToSubStore()
                }}
                className="btn btn-primary"
              >
                ADD
              </button>
            </Modal.Footer>
        )}
      
      </Modal>
      {spinner ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Card
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <Card.Header>
            <div></div>
            <button
              onClick={() => {
                history.push(`/Store-Managment/459fhu4749fhfhf7585/Create`);
              }}
              className="btn btn-primary"
            >
              Add Stores
            </button>
          </Card.Header>
          <Card.Body>
              <div id="job_data" className="dataTables_wrapper ">
                <Table className="text-white">
                  <thead>
                    <tr>
                      <th>
                        <strong>NAME</strong>
                      </th>
                      <th>
                        <strong>Address</strong>
                      </th>
                    
                      <th>
                        <strong>CityName</strong>
                      </th>
                      <th>
                        <strong>Fssalic Code</strong>
                      </th>

                      <th>
                        <strong>Actions</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {stores &&
                      stores.map((val, key) => (
                        <tr key={val.id}>
                          <td>{val.Name}</td>
                          <td>{val.Address}</td>
                        
                          <td>{val.CityName}</td>
                          <td>{val.FssaiCode}</td>

                         
                          <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push(
                                    `/Store-Managment/${val._id}/Update`,
                                    val
                                  );
                                }}
                              >
                                Update
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                  getCategory(val.SubShop)
                                  setDeleteStatus(false)
                                 
                                }}
                              >
                                Add SubShop
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                  getCategory(val.SubShop)
                                  setDeleteStatus(true)
                                }}
                              >
                                Remove SubShop
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>

                {stores.length===0 && (
                  <Alert
                    variant="success"
                    className="alert-dismissible fade show text-center"
                  >
                    Zero stores
                  </Alert>
                )}
              </div>
            </Card.Body>
        </Card>
      )}
    </Col>
  );
}

export default Stores;
